import React from "react";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { useEffect } from "react";
import "./monitoring.css";
// Import the marker icon
import {
  redMarkerIcon,
  greenMarkerIcon,
  markerShadow,
} from "src/util/mapImages";
import { useNavigate, useRouteLoaderData, defer } from "react-router-dom";
import { useState } from "react";
import MapWithDifferentLevels from "./mapsWithDifferentLevelTest";
import { getSite, deleteBuilding } from "src/apis/complex";
import { checkBuildingAlarms,determineBuildingsWithAlarms } from "src/util/utilFunctions";
import { useAlertContext } from "src/hooks/use-alert";

const greenMarker = new L.Icon({
  iconUrl: greenMarkerIcon,
  iconRetinaUrl: greenMarkerIcon,
  shadowUrl: markerShadow,
  iconSize: [27, 40],
  iconAnchor: [16, 32],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const redMarker = new L.Icon({
  iconUrl: redMarkerIcon,
  iconRetinaUrl: redMarkerIcon,
  shadowUrl: markerShadow,
  iconSize: [27, 40],
  iconAnchor: [16, 32],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

function ZoomedOutMonitoringSiteDetail() {
  const alert = useAlertContext();
  const siteObject = useRouteLoaderData("zoomMonitoringSiteDetail");
  var locations = [];
  const [locations_, setLocations_] = useState([]);
  const [siteAlarms, setSiteAlarms] = useState([]);
  const [mapCenter, setMapCenter] = useState(null);
  const navigate = useNavigate();
  const handleMarkerClick = (building) => {
    if (building) {
      navigate(
        `/dashboard/explore-complexes/${siteObject.site.id}/building/${building.id}`
      );
    }
  };
  const handleSwitchViewClick = () => {
    navigate(`/dashboard/explore-complexes/${siteObject.site.id}`);
  };

  const updateSite = async () => {
    await getSite(siteObject.site.id).then((res) => {
      if (res) {
        const itemsWithAlarms = checkBuildingAlarms(res.buildings);
        const buidingsWithAlarms=determineBuildingsWithAlarms(res,itemsWithAlarms) 
        locations = buidingsWithAlarms;
        setLocations_(locations);
      }
    });
  };


  useEffect(() => {
    if (alert.alarmPageUpdate) { 
      const timeoutId = setTimeout(() => {
        updateSite();
      }, 900); 
     
      alert.setAlarmPageUpdate(false)
    } // fetch new sites 


  }, [alert.alarmPageUpdate]);


  useEffect(() => {
    if (siteObject && siteObject.site) {
      // Ensure siteObject.site is not null, undefined, and has a valid length before calling checkBuildingAlarms
      const itemsWithAlarms =
        siteObject.site.buildings && siteObject.site.buildings.length > 0
          ? checkBuildingAlarms(siteObject.site.buildings)
          : [];
      setSiteAlarms(itemsWithAlarms);
      setMapCenter([
        parseFloat(siteObject.site.latitude),
        parseFloat(siteObject.site.longitude),
      ]);
      locations=determineBuildingsWithAlarms(siteObject.site,itemsWithAlarms);
      setLocations_(locations);
    }
  }, [siteObject]);

  return (
    <>
      {mapCenter && (
        <MapWithDifferentLevels
          headerTitle={"Site Buildings"}
          center={mapCenter}
          locations={locations_}
          zoomLevel={20}
          clickHandleMarker={handleMarkerClick}
          clickHandleButton={handleSwitchViewClick}
        />
      )}
    </>
  );
}

export default ZoomedOutMonitoringSiteDetail;

async function loadComplex(id) {
  const response = await getSite(id);
  return response;
}

export async function loader({ request, params }) {
  const id = params.siteId;

  return defer({
    site: await loadComplex(id),
  });
}
